import { useMsal } from '@azure/msal-react';
import { useCallback } from "react";
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { apiScope, apiTokenRequest } from "../authConfig";
import { useUser } from '../components/UserContext';
export default function useAuthToken() {
    const { instance, accounts } = useMsal();

    const getAccessToken = useCallback(async () => {
        const userAccount = accounts[0];

        const request = {
            scopes: [apiScope],
            account: accounts[0]
        };

        if (!userAccount) {
            console.warn("No account available for token acquisition.");
            return null;
        }

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                // re-authenticate (session expired)
                await instance.acquireTokenRedirect(request);
            } else {
                return null;
            }
        }
    }, [accounts, instance]);

    return getAccessToken;
};

export const useAuthProviders = () => {
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const { activeClientId } = useUser();
    const scopes = [apiScope];

    return {
        getAccessToken: async () => {
            if (!account) return null;
            const res = await instance.acquireTokenSilent({ account, scopes });
            return res.accessToken;
        },
        getClientId: () => { return activeClientId },
        refreshToken: async () => {
            if (!account) return;
            //await instance.acquireTokenSilent({ account, scopes, forceRefresh: true });
            const res = await instance.acquireTokenSilent({ ...apiTokenRequest, account });
            return res.accessToken;
        },
    };
};


